var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMoveLeftArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M5.5 18.5V18.5C5.5 20.7091 7.29086 22.5 9.5 22.5H18.5C20.7091 22.5 22.5 20.7091 22.5 18.5V9.5C22.5 7.29086 20.7091 5.5 18.5 5.5H9.5C7.29086 5.5 5.5 7.29086 5.5 9.5V9.5",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.5 14L12.0355 17.5355M8.5 14L12.0355 10.4645M8.5 14L17.6924 14",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMoveLeftArrow);
export default __webpack_public_path__ + "static/media/move-left-arrow.6d09fbb80d2d9cf368bf65c376026bb7.svg";
export { ForwardRef as ReactComponent };